export default class filter_array {
  get_modelli_a(array) {
    let t = [];
    try {
      array.forEach((element) => {
        // array push t element modello
        if (!t.includes(element["SORGENTE"])) {
          t.push(element["SORGENTE"]);
        }
      });
    } catch (error) {
      console.info(error);
    }
    return t;
  }
  // questa funzione a partire dal codice univoco prodotto usa mi da il codice prodotto europa e viceversa
  get_product_from_product( state) {
    try {
      let codice_univoco =   state.product_store.CODICE_UNIVOCO;
      console.info('get_product_from_product codice univoco', codice_univoco);

    let details = state.products_store.DETAILS;
    let prodotto = details.filter( (detail) =>{
      return detail.id_prodotto == codice_univoco;
    } );

    console.info('paese_seleted prdotto:',  prodotto);
    let p = prodotto[0];
    console.info('paese_seleted prdotto:',  p );

if (prodotto.length > 0){
        let finitura_vetro = p.testo_finitura;
        let finitura_montatura = p.testo_finiturastruttura;
        let modello = p.model;
        let paese = p.PAESE;
        let paese_seleted = 'UL';
        if (paese == 'UL'){ 
           paese_seleted = 'CE';
        }
        let prodotto = details.filter( (detail) =>{
      return detail.testo_finitura == finitura_vetro &&
            detail.testo_finiturastruttura == finitura_montatura &&
            detail.model == modello &&
            detail.PAESE == paese_seleted;
    } );
   

    console.info('paese_seleted F', finitura_vetro, finitura_montatura, modello, paese, paese_seleted, prodotto);

    if (prodotto.lenght >0 ){
      return prodotto;
    }else{
      prodotto = details.filter( (detail) =>{
        return detail.testo_finitura == finitura_vetro &&
        detail.testo_finiturastruttura == finitura_montatura &&
    
        detail.PAESE == paese_seleted;
} );
 console.info('paese_seleted G' ,  prodotto);
 window.descrizione.codice_prodotto = prodotto[0].id_prodotto;
 state.product_store.CODICE_UNIVOCO = prodotto[0].id_prodotto;
     return prodotto[0];
    }
}

 } catch (error) {
    console.info('paese_selected H', error)   
}

}         


  riordina_prezzi(state) {
    try {
      let sorgente = state.products.SORGENTE;
      
      console.info('riodina_prezzi', sorgente);
      console.info('riodina_prezzi', state);
      sorgente.sort(function (a, b) {
        return parseFloat(a.PRICE) - parseFloat(b.PRICE);
      });
      if (sorgente[0].famiglia == "GIOGA") {
        sorgente.sort(function (a, b) {
          return a.MODELLO.localeCompare(b.MODELLO);
        });
      }

      return sorgente;
    } catch (error) {
      let sorgente = state.products.SORGENTE;
      return sorgente;
    }
  }
  riordina_prezzi2(modelli) {
    try {
      let sorgente = modelli;
      sorgente.sort(function (a, b) {
        return parseFloat(a.PRICE) - parseFloat(b.PRICE);
      });
      if (sorgente[0].famiglia == "GIOGA") {
        sorgente.sort(function (a, b) {
          return a.MODELLO.localeCompare(b.MODELLO);
        });
      }

      return sorgente;
    } catch (error) {
      let sorgente = modelli;
      return sorgente;
    }
  }
  key_value(array, filter_key, filter_value, silent = true) {
    this.silent = silent;
    let filtered_array = [];
    try {
      array.forEach(function (item) {
        if (item[filter_key] == filter_value) {
          filtered_array.push(item);
        }
      });
    } catch (error) {
      console.info(error);
    }
    return filtered_array;
  }
  seleziona_prodotti_con_immagini_diverse(array){
   try {
    let c = [];
    let img = [];
    array.forEach(function (item){
      if (!img.includes(item.IMG_B)){
        img.push(item.IMG_B);
        c.push(item);
      }
    });
      return c;    
   } catch (error) {
    console.log(error);
    return array;
   }
  }

  select_from_array_key_value(array, filter_key, filter_value) {
    let filtered_array = [];
    try {
      array.forEach(function (item) {
        if (item[filter_key] == filter_value) {
          filtered_array.push(item);
        }
      });
    } catch (error) {
      console.info(error);
    }
    return filtered_array;
  }
  group_by(array, filter_key) {
    let result = [];
    try {
      array.forEach(function (item) {
        item.model = item[filter_key];
        result.push(item.model);
      });
    } catch (error) {
      console.info(error);
    }
    let distinct = (value, index, self) => {
      return self.indexOf(value) === index;
    };
    return result.filter(distinct);
  }
  group_by_value(array, key) {
    let result = [];
    try {
      array.forEach(function (item) {
        result.push(item[key]);
      });
    } catch (error) {
      console.info(error);
    }
    return result;
  }

  group_by_type(array, array_b, array_key, silent = true) {
    this.silent = silent;
    let s = [];
    try {
      array_b.forEach((item) => {
        let r = this.key_value(array, array_key, item, false);
        let a = this.take_first(r);
        if (typeof a !== "undefined") {
          s.push(a);
        }
      });
    } catch (error) {
      console.info(error);
    }

    return s;
  }

  get_modelli(array) {
    let t = [];
    try {
      array.forEach((element) => {
        if (!t.includes(element.MODELLO)) {
          t.push(element["MODELLO"]);
        }
      });
    } catch (error) {
      console.info(error);
    }
    return t;
  }

  group_by_modello_e_modello_var(prodotti, variazioni, modelli) {
    let s = [];
    try {
      variazioni.forEach((variazione) => {
        let prodotti_variazioni = this.select_from_array_key_value(
          prodotti,
          "modello_var",
          variazione,
          false
        );
        modelli.forEach((modello) => {
          let prodotti_variazione_modello = this.select_from_array_key_value(
            prodotti_variazioni,
            "MODELLO",
            modello,
            false
          );
          let a = this.take_first(prodotti_variazione_modello);
          if (typeof a !== "undefined") {
            s.push(a);
          }
        });
      });
    } catch (error) {
      console.info(error);
    }
    // TO DO controllo se ci sono elementi che hanno tutto uguale tranne alimentazione
    return s;
  }

  take_first(array) {
    return array[0];
  }

  select_by_key_value(array, key, value, key_selected) {
    let r = [];
    try {
      array.forEach(function (item) {
        if (item[key] == value) {
          item[key_selected] = true;
          r.push(item);
        } else {
          item[key_selected] = false;
          r.push(item);
        }
      });
    } catch (error) {
      console.info(error);
    }
    return r;
  }

  select_by_key_value_mv(array, modello, modello_var) {
    let r = [];
    let find = false;
    try {
      array.forEach(function (item) {
        if (
          item["MODELLO"] == modello &&
          item["modello_var"] == modello_var &&
          find == false
        ) {
          item["SELECTED"] = true;
          find = true;
          r.push(item);
        } else {
          item["SELECTED"] = false;
          r.push(item);
        }
      });
    } catch (error) {
      console.info(error);
    }
    if (find == false) {
      r[0].SELECTED = true;
    }
    return r;
  }
  select_by_modello_and_modello_var(array, modello_var, modello) {
    // metti tutto a false
    try {
      array.forEach((element) => {
        element["SELECTED"] = false;
      });
    } catch (error) {
      console.info(error);
    }
    // METTO A TRUE SOLO QUELLO CHA HA MODELLO E MODELLO VAR UGUALI E SOLO IL PRIMO ELEMENTO
    let selected = true;
    try {
      array.forEach((element) => {
        if (
          element["MODELLO"] == modello &&
          element["modello_var"] == modello_var
        ) {
          element["SELECTED"] = selected;
          selected = false;
        }
      });
    } catch (error) {
      console.info(error);
    }
    return array;
    // FACCIO IL COUNT DI SELECTED A TRUE
  }

  select_by_key_value_one(array, key, value, key_d) {
    let r = [];
    try {
      array.forEach(function (item) {
        if (item[key] == value) {
          r.push(item);
        }
      });
    } catch (error) {
      console.info(error);
    }
    if (r.length == 0) {
      return 0;
    }
    return r[0][key_d];
  }

  select_by_key_value_one_listino(array, key, value, key_d, listino) {
    let r = [];
    try {
      array.forEach(function (item) {
        if (item[key] == value) {
          r.push(item);
        }
      });
    } catch (error) {
      console.info(error);
    }
    if (r.length == 0) {
      return 0;
    }
    try {
      r.forEach((element) => {
        if (element.Codice_listino == listino) {
          return element[key_d];
        }
      });
    } catch (error) {
      console.info(error);
    }
    return r[0][key_d];
  }
  select_by_key_value_one_array(array, key, value) {
    let r = [];
    try {
      array.forEach(function (item) {
        if (item[key] == value) {
          r.push(item);
        }
      });
    } catch (error) {
      console.info(error);
    }
    return r;
  }

  key_value_exist(array, key, value) {
    let exist = false;
    try {
      array.forEach(function (item) {
        if (item[key] == value) {
          exist = true;
        }
      });
    } catch (error) {
      console.info(error);
    }
    return exist;
  }
  search_id_product_exist(array, a, b, c, d) {
    let result = false;
    console.info('search_id_product_exist',array, a, b, c, d);
    let e = this.select_by_key_value_one_array(array, "COLOREVETRO", a);
    console.info(e);
    e = this.select_by_key_value_one_array(e, "testo_finiturastruttura", b);
    console.info(e);
    e = this.select_by_key_value_one_array(e, "SORGENTE", c);
    console.info(e);
    e = this.select_by_key_value_one_array(e, "modello_var", d);
    console.info(e);
    try {
      if (e.length > 0) {
        result = true;
      }
    } catch (error) {
      console.info(error);
    }

    return result;
  }

  exist_value_in_array(array, value) {
    let exist = false;
    if (Array.isArray(array)) {
      try {
        array.forEach(function (item) {
          if (item == value) {
            exist = true;
          }
        });
      } catch (error) {
        console.info(error);
      }
    }
    return exist;
  }
}
